module.exports = __webpack_public_path__ + "static/media/cyan-cluster.86bcf682.svg";